/**
 * Counts the number of data rows in a CSV file (excluding the header row)
 * @param file - The CSV file to process
 * @returns Promise<number> - The count of data rows
 */
export async function countCsvRows(file: File): Promise<number> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = event => {
      try {
        const text = event.target?.result as string;
        if (!text) {
          resolve(0);
          return;
        }

        // Split by newlines and filter out empty lines
        const lines = text
          .split('\n')
          .map(line => line.trim())
          .filter(line => line.length > 0);

        // Subtract 1 for header row, or return 0 if no data rows
        const dataRowCount = Math.max(0, lines.length - 1);
        resolve(dataRowCount);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
}
